import { Badge } from '../../catalyst/badge';

export default function QueueBadge({ depth }: { depth: number }) {
  const color = depth === 0 ? 'zinc' : depth < 100 ? 'amber' : 'red';
  return <Badge color={color}>{depth >= 1000 ? `${(depth / 1000).toFixed(1)}k` : depth}</Badge>;
}
